import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { getActionableCases, selectActionableCases, selectLoadingActionableCases } from "./ActionableCasesSlice";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { Link } from "react-router-dom";
import { ICasesService } from "services/CasesService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { CaseModel } from "services/api/cplapi/CPLAPI";

const ActionableCases: React.FC = () => {
  const thunkDispatch = useThunkDispatch();
  const loadingActionableCases = useSelector(selectLoadingActionableCases);
  const actionableCases = useSelector(selectActionableCases);
  const sortedActionableCases = [...actionableCases];
  const casesService = container.get<ICasesService>(SERVICE_TYPES.CasesService);

  useEffect(() => {
    thunkDispatch(getActionableCases());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    sortedActionableCases.sort((a, b) => {
      if (a.slaTarget! >= b.slaTarget!) {
        return -1;
      } else {
        return 1;
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionableCases]);

  function getTimeRemaining(caseModel: CaseModel) {
    return casesService.getTimeRemaining(caseModel);
  }

  return (
    <div className="card dashboard-card">
      <div className="card-header">
        <div className="card-title">Actionable Cases</div>
      </div>
      <div className="card-body dashboard-card-body">
        <ActivityIndicator isBusy={loadingActionableCases} busyMessage="Getting Daily Itinerary">
          {(sortedActionableCases.length > 0 &&
            sortedActionableCases.map((i) => {
              const timeRemaining = getTimeRemaining(i);
              return (
                <div key={i.caseID} className="pb-1 pt-1">
                  <Link
                    data-test-id={`actionable-cases-card__view-case-link-${i.caseID}`}
                    className="ps-3 row"
                    to={`/Case/${i.caseID}/Details`}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="View Case"
                  >
                    <div className="col-sm-7">{i.title}</div>
                    <div
                      className={`col-sm-5 ${timeRemaining!.dueToday ? "duetoday-time-remaining" : ""} ${
                        timeRemaining.taskOverdue ? "overdue-time-remaining" : ""
                      }`}
                    >
                      {timeRemaining.timeRemainingString}
                    </div>
                  </Link>
                </div>
              );
            })) ||
            (!loadingActionableCases && <>Looks like you have no open cases</>)}
        </ActivityIndicator>
      </div>
    </div>
  );
};

export default ActionableCases;
